import React from 'react';

const Error = () => {
  return (
    <div className="Error">
      <div className="alert alert-danger" role="alert">
        <h1 className="alert-heading">Error</h1>
      </div>
    </div>
  );
};

export default Error;
